import { render, staticRenderFns } from "./EventRank.vue?vue&type=template&id=2d6b9250&"
import script from "./EventRank.vue?vue&type=script&lang=js&"
export * from "./EventRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports